import { render, staticRenderFns } from "./fileda.vue?vue&type=template&id=42f4e639&"
import script from "./fileda.vue?vue&type=script&lang=js&"
export * from "./fileda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports